import {SaleSashPosition, ProductType} from "../../config/constants"
import {SummaryType} from "../../models/searchApi"
import {showFitsIcons} from "./showFitsIcons"

export function getShowFitIconsByType(
    type: SummaryType,
    department: string,
    {isOnSale, saleSashPosition}: {isOnSale: boolean; saleSashPosition: SaleSashPosition | null},
    displayFitIcons: boolean,
) {
    switch (type) {
        case ProductType:
            return showFitsIcons(isOnSale, saleSashPosition, department, displayFitIcons)
        default:
            return false
    }
}
